import { useEffect, useRef, useState } from 'react';

const SEGUNDO = 1000;
const MINUTO = 60 * SEGUNDO;
const HORA = 60 * MINUTO;
const DIA = 24 * HORA;

function calcularRestante(alvoMs) {
  const restanteMs = alvoMs - Date.now();
  if (restanteMs <= 0) return { encerrou: true, dias: 0, horas: 0, minutos: 0, segundos: 0 };
  return {
    encerrou: false,
    dias: Math.floor(restanteMs / DIA),
    horas: Math.floor((restanteMs % DIA) / HORA),
    minutos: Math.floor((restanteMs % HORA) / MINUTO),
    segundos: Math.floor((restanteMs % MINUTO) / SEGUNDO)
  };
}

// Contagem regressiva até `dataEncerramentoIso` (mesmo enquete.data_encerramento
// que FormularioDinamico.js já recebe de obterDefinicao). Usa Date.getTime()
// puro — SEM o ajuste de -4h que formatarDataEncerramento.js faz: aquele
// ajuste é só pra exibir os dígitos de calendário corretos ("como configurado
// em Corumbá", ver comentário lá); aqui o que importa é o instante real
// (mysql2 já resolveu o fuso -04:00 na gravação, ver database.js), então a
// diferença crua contra Date.now() já é o tempo restante certo — igual pra
// qualquer visitante em qualquer fuso, sem precisar descobrir onde ele está.
//
// Reagenda a cada segundo por padrão, mas cai pra 1x/hora quando faltam 3+
// dias (mesmo LIMITE_DIAS_DETALHADO de formatarContagem.js) — não faz
// sentido re-renderizar todo segundo um texto que só muda de hora em hora.
export function useContagemRegressiva(dataEncerramentoIso) {
  const alvoMs = dataEncerramentoIso ? new Date(dataEncerramentoIso).getTime() : NaN;
  const valido = !!dataEncerramentoIso && !Number.isNaN(alvoMs);
  const [restante, setRestante] = useState(() => (valido ? calcularRestante(alvoMs) : null));
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (!valido) {
      setRestante(null);
      return undefined;
    }

    const atualizar = () => {
      const novo = calcularRestante(alvoMs);
      setRestante(novo);
      if (!novo.encerrou) {
        const passo = novo.dias >= 3 ? HORA : SEGUNDO;
        timeoutRef.current = setTimeout(atualizar, passo);
      }
    };

    atualizar();
    return () => clearTimeout(timeoutRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alvoMs, valido]);

  return restante;
}
